import React from 'react';
import ButtonChoice from '../Fields/ButtonChoice';

const ExcessBuildingsCover = React.createClass({
    propTypes: {
        regenerateQuote: React.PropTypes.func,
    },

    regenerateQuote : function() {
        this.props.regenerateQuote();
    },

    render() {
        return (
            <div className="container has-border">
                <div className="summary-question">
                    <ButtonChoice
                        question={'What level of excess would you like for your building cover?'}
                        fieldName={'building_insurance_excess'}
                        loadCachedValue={true}
                        children={[]}
                        questionId={null}
                        supplementaryText={''}
                        supplementaryTextAfterInput={null}
                        alternateBackground={null}
                        noBorder={true}
                        onChangeTertiary={this.regenerateQuote}
                        helpText={null}
                        options={[
                            {
                                option_text: '£0',
                                option_value: '0'
                            },
                            {
                                option_text: '£100',
                                option_value: '100'
                            },
                            {
                                option_text: '£250',
                                option_value: '250'
                            },
                            {
                                option_text: '£500',
                                option_value: '500'
                            },
                            {
                                option_text: '£1,000',
                                option_value: '1000'
                            },
                        ]} />
                </div>
            </div>
        );
    }
});

export default ExcessBuildingsCover;



/** WEBPACK FOOTER **
 ** ./src/components/QuoteSummaryFields/ExcessBuildingsCover.js
 **/